import { apiRequest, withToken } from './http-client';

export const register = async ( company, firstName, lastName, email, password ) => {
    return apiRequest({
        method: 'post',
        url: '/auth/register/',
        data: {
            company,
            name: `${firstName} ${lastName}`,
            firstName,
            lastName,
            email,
            password
        }
    }, 'No se pudo completar el registro');
}

export const login = async ( email, password ) => {
    return apiRequest({
        method: 'post',
        url: '/auth/login/',
        data: { email, password }
    }, 'No se pudo iniciar sesión');
}

export const authMe = async ( token ) => {
    return apiRequest({
        method: 'post',
        url: '/auth/auth-me/',
        headers: withToken(token)
    }, 'No se pudo validar la sesión');
}

export const verifyEmail = async ( token, code ) => {
    return apiRequest({
        method: 'post',
        url: '/auth/verify-email/',
        headers: withToken(token),
        data: { code }
    }, 'No se pudo verificar el código');
}

export const resendVerificationEmail = async ( token ) => {
    return apiRequest({
        method: 'post',
        url: '/auth/resend-verification-email/',
        headers: withToken(token)
    }, 'No se pudo reenviar el código');
}

export const requestPasswordReset = async ( email ) => {
    return apiRequest({
        method: 'post',
        url: '/auth/recovery-password/',
        data: { email }
    }, 'No se pudo solicitar el restablecimiento de contraseña');
}

export const resetPassword = async ( token, newPassword ) => {
    return apiRequest({
        method: 'post',
        url: '/auth/reset-password/',
        data: { token, newPassword }
    }, 'No se pudo restablecer la contraseña');
}

export const activateAccount = async ( token, newPassword ) => {
    return apiRequest({
        method: 'post',
        url: '/auth/activate-account/',
        data: { token, newPassword }
    }, 'No se pudo activar la cuenta');
}